<nb-card>
  <nb-card-header>
    <div class="menu-buttons">
      <button
        [ngClass]="menu == 'a4' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'a4' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('a4')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        <span>A4</span>
      </button>
    </div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <ngx-layout-finance-a4
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [finance]="finance"
    >
    </ngx-layout-finance-a4>
  </nb-card-body>

  <nb-card-footer>
    <!--- This is hidden using CSS ----->
    <button
      type="button"
      class="btn btn-sm d-none"
      ngxPrint
      printSectionId="print-section"
      styleSheetFile="assets/css/layout-print.css"
      #printBtn
      ngxPrint
    >
      Auto Print
    </button>

    <button
      *ngIf="!printing"
      nbButton
      hero
      shape="semi-round"
      status="info"
      size="medium"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
